export default {
  s3: {
    REGION: "ap-northeast-1",
    BUCKET: "owlstart-uploads"
  },
  cognito: {
    REGION: "ap-northeast-1",
    // beta (=rcls) current user pool
    USER_POOL_ID: "ap-northeast-1_BdGy2m6ZP",                                   // owl-beta-pool
    APP_CLIENT_ID: "47l3bb68hrm736uhef642pckvg",                                // owl-beta-client
    IDENTITY_POOL_ID: "ap-northeast-1:dc4c3d0b-cd7d-440c-b6a2-5155d49a3f9f"     // owl_federated_beta
  },
  //callback URL
  owl_callback:{
    // NEW Version
//    starterNew : "http://192.168.21.191/owl/awsin.mics",
//    createUserNew : "http://192.168.21.191/owl/psg6g2IQ80deDw95JckR+WzNUNMqxlIOX5Wed9n+96w=.mics",
    starterNew : "https://owl-sys-beta.owl-developer.net/owl/awsin.mics" ,
    createUserNew : "https://owl-sys-beta.owl-developer.net/owl/psg6g2IQ80deDw95JckR+WzNUNMqxlIOX5Wed9n+96w=.mics",
    // Beta Server
    starter : "https://owl-sys-beta.owl-developer.net/owl/awsin.mics" ,
    createUser : "https://owl-sys-beta.owl-developer.net/owl/psg6g2IQ80deDw95JckR+WzNUNMqxlIOX5Wed9n+96w=.mics"
    /* local dev
    //starter : "http://localhost:8080/owl/awsin.mics",
    //createUser : "http://localhost:8080/owl/psg6g2IQ80deDw95JckR+WzNUNMqxlIOX5Wed9n+96w=.mics"
    */
    // #4285, Add 셧다운예정시각, 작업 안내 공지 팝업 여부 yyyyMMddHH.
    ,shutdownDateTime : "2026071516"
    ,shutdownEndDateTime : "2026071517"
    ,jobDateTime : "07/15（水曜日）16：００～17：００は "
  },
  cognitoUser:{}
};


/**
 금요일	金曜日 (킨요-비)	Friday
 토요일	土曜日 (도요-비)	Saturday
 일요일	日曜日 (니치요-비)	Sunday
 월요일	月曜日 (게츠요-비)	Monday
 화요일	火曜日 (카요-비)	Tuesday
 수요일	水曜日 (스요-비)	Wednesday
 목요일	木曜日 (모쿠요-비)	Thursday
* */